// extracted by mini-css-extract-plugin
export default {"zoomModal":"k2-z","image":"l2-z","button":"m2-z","isOverlayShown":"n2-z"};